<div class="flex-row" style="margin-top: 20px;">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-5">
        <div class="card-group mb-0">
          <div class="card p-4 card-full-border">
            <div class="card-body">
              <div class="lr-logo"></div>
              <h4>AllAssets</h4>
              <ng-content select="[content]"></ng-content>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>